<template>
  <div>
    <el-row>
      <el-form :inline="true" class="demo-form-inline" style="padding-top:0;margin-top:20px"
        :model="searchForm" ref="searchForm">
        <el-form-item label="名称：">
          <el-input size="medium" placeholder="名称" v-model="searchForm.NAME" clearable
            @keyup.enter.native="handleSearch()"></el-input>
        </el-form-item>
        <el-form-item label="电话：">
          <el-input size="medium" placeholder="名称" v-model="searchForm.CELLPHONE" clearable
            @keyup.enter.native="handleSearch()"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="medium" type="primary" id="search" @click="handleSearch()">筛选</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-col :span="4">
        <el-button size="medium" @click="openAdd" style="margin-bottom:10px">新增</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="tableData" border stripe style="width: 100%">
          <el-table-column type="index" label="序号" width="50" min-width="30"></el-table-column>
          <el-table-column prop="NAME" label="姓名"></el-table-column>
          <el-table-column prop="CELLPHONE" label="电话"></el-table-column>
          <el-table-column fixed="right" label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small" icon="el-icon-edit" @click="edit(scope.row)">修改</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <div class="block" style="float: right">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total, prev, pager, next, jumper" :total="totalCount"></el-pagination>
    </div>
    <!-- 新增模态框 -->
    <el-dialog title="新增人员" center :visible.sync="addFormVisible" width="500px" :close-on-click-modal="false">
      <el-form size="small" :model="addForm" ref="addForm" style="margin-top: 0" :rules="rules">
        <el-form-item label="名称：" :label-width="formLabelWidth" prop="NAME">
          <el-input v-model="addForm.NAME" auto-complete="off" clearable></el-input>
        </el-form-item>
        <el-form-item label="电话：" :label-width="formLabelWidth" prop="CELLPHONE">
          <el-input v-model="addForm.CELLPHONE" auto-complete="off" clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close('addForm')">取 消</el-button>
        <el-button size="small" :loading="loading" @click="submitAction('addForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 修改模态框 -->
    <el-dialog title="新增人员" center :visible.sync="editFormVisible" width="500px" :close-on-click-modal="false">
      <el-form size="small" :model="editForm" ref="editForm" style="margin-top: 0">
        <el-form-item label="名称：" :label-width="formLabelWidth" prop="NAME">
          <el-input v-model="editForm.NAME" auto-complete="off" clearable></el-input>
        </el-form-item>
        <el-form-item label="电话：" :label-width="formLabelWidth" prop="CELLPHONE">
          <el-input v-model="editForm.CELLPHONE" auto-complete="off" clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close('editForm')">取 消</el-button>
        <el-button size="small" :loading="editLoad" @click="submitedit('editForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { queryPerson, addPerson, updatePerson } from '@/assets/api/customerManage';
import { frontEndFun } from '@/assets/api/frontFun';

export default {
  data() {
    return {
      PAGE_ID: '10034', // 页面ID 一旦规定不要轻易改动
      fun_dic: { 1003401: 0, 1003402: 0 },
      customer_name: sessionStorage.getItem('CUSTOMER_NAME'),
      rules: {
        NAME: [
          { required: true, message: '请输入名称', trigger: 'blur' },
        ],
        CELLPHONE: [
          { required: true, message: '请输入电话', trigger: 'blur' },
        ],
      },
      loading: false,
      editLoad: false,
      searchForm: {},
      tableData: [],
      currentPage: 1,
      // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) || 10,
      totalCount: 0,
      addFormVisible: false,
      addForm: {},
      formLabelWidth: '100px',
      editFormVisible: false,
      editForm: {},
    };
  },
  created() {
    this.queryBeforeFun();
    this.queryTable();
  },
  methods: {
    // 控制功能按钮
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      frontEndFun(params)
        .then((result) => {
          if (result.length !== 0) {
            this.forMenu(result, this.fun_dic);
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    // 修改
    edit(row) {
      this.editFormVisible = true;
      this.editForm = row;
    },
    submitedit() {
      const params = {
        TC_USER_ID: this.editForm.ID,
      };
      if (this.editForm.CELLPHONE) {
        params.CELLPHONE = this.editForm.CELLPHONE;
      }
      if (this.editForm.NAME) {
        params.NAME = this.editForm.NAME;
      }
      this.editLoad = true;
      updatePerson(params)
        .then((result) => {
          this.$message.show({ text: '修改成功', type: 'success' });
          this.editLoad = false;
          this.editFormVisible = false;
          this.queryTable();
        }).catch((error) => {
          this.editLoad = false;
          this.$message.show({ text: error, type: 'error' });
        });
      this.editFormVisible = false;
      this.queryTable();
    },
    // 新增
    openAdd() {
      this.addFormVisible = true;
    },
    submitAction(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = {
            TC_ID: Number(sessionStorage.getItem('customerId')),
            NAME: this.addForm.NAME,
            CELLPHONE: this.addForm.CELLPHONE,
          };
          this.loading = true;
          addPerson(params)
            .then((result) => {
              this.$message.show({ text: '新增成功', type: 'success' });
              this.loading = false;
              this.addFormVisible = false;
              this.queryTable();
              this.addForm = {};
            }).catch((error) => {
              this.loading = false;
              this.$message.show({ text: error, type: 'error' });
            });
        } else {
          return false;
        }
      });
    },
    queryTable() {
      const params = {
        TC_ID: Number(sessionStorage.getItem('customerId')),
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      if (this.searchForm.NAME) {
        params.NAME = this.searchForm.NAME;
      }
      if (this.searchForm.CELLPHONE) {
        params.CELLPHONE = this.searchForm.CELLPHONE;
      }
      queryPerson(params)
        .then((result) => {
          if (result.length !== 0) {
            this.tableData = result[0].list;
            this.totalCount = result[0].TOTAL_COUNT;
          } else {
            this.$message.show({ text: '暂无数据', type: 'success' });
            this.tableData = [];
            this.totalCount = 0;
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 筛选
    handleSearch() {
      this.currentPage = 1;
      this.queryTable();
    },
    // 分页
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryTable();
    },
    // 取消
    close(formName) {
      this.$refs[formName].resetFields();
      const modalName = `${formName}Visible`;
      this[`${modalName}`] = false;
      this.queryTable();
      this.addForm = {};
    },

  },
};
</script>



// WEBPACK FOOTER //
// src/components/customerManage/personDetail.vue